import React from 'react';

interface ResultListProps {
  values: string[];
  codes: string[];
}

const ResultList: React.FC<ResultListProps> = ({ values, codes }) => {
  return (
    <div id="result-container">
      {values.length > 0 && (
        <table id="codes">
          <thead>
            <tr>
              <th>Code</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {values.map((value, index) => (
              <tr key={index}>
                <td>{codes[index]}</td>
                <td>{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ResultList;
